import React from 'react';

import Button from '@atlaskit/button/default/button';

export default function ButtonDangerExample(): React.JSX.Element {
	return <Button appearance="danger">Danger button</Button>;
}
